import {colors} from "@c10h/colors";
import {useTranslation} from "ni18n";
import React from "react";

import {Btn} from "../V5Comp";
import styles from "./How.module.scss";

const How = () => {
  const i18n = useTranslation();

  const data = [
    {
      icon: "monitor-plus",
      title: i18n.t("Management & Containment"),
      body: i18n.t(
        "Get updates on employees’ COVID-19 test results through your customized employer dashboard. Should any of your employees exhibit symptoms, we have step-by-step plans in place and medical staff who are able to advise on next steps.",
      ),
    },
    {
      icon: "flu-screening",
      title: i18n.t("Testing & Vaccinations"),
      body: i18n.t(
        "We can provide COVID-19 testing onsite, in one of our nationwide clinics, or administer them at home. We also offer COVID-19 vaccinations and boosters in our clinics and at onsite events.",
      ),
    },
    {
      icon: "conversation-chat-bubble",
      title: i18n.t("Medical Protocols"),
      body: i18n.t(
        "Our medical team provides COVID-19 workplace protocols and operational best practices grounded in scientific research, so you can stay safe in and out of work.",
      ),
    },
  ];

  return (
    <div className={styles.wrap} id="how">
      <div className={styles.inner}>
        <div className="tac mb24">
          <h5 className={styles.head1}>{i18n.t("How it works")}</h5>
          <h2 className={styles.head2}>{i18n.t("Minimize workplace risk")}</h2>
          <p className={styles.subHead}>
            {i18n.t(
              "Testing is not enough. Make sure you have all the pieces in place to safely and responsibly open and operate.",
            )}
          </p>
          <Btn className={styles.start} bg={colors.darkGreen} href="#signup">
            {i18n.t("Talk to Our Team")}
          </Btn>
        </div>

        <ul className="dg mt12 gtc3fr af-md maxw36-md ma gg8 mb12">
          {data.map(d => (
            <li key={d.icon}>
              <span className={`${styles.fIcon} cIcon-${d.icon}`} />
              <h4 className={styles.fHead}>{d.title}</h4>
              <p className={styles.fSub}>{d.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default React.memo(How);
